import React, { useEffect, useRef, useState } from 'react'
import { storage, ref, getDownloadURL, getAuth, signInWithCustomToken } from "../../services/firebase/firebase";
import ScrollBar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ProgressBar from "./ProgressBar"
import SpeakerBar from './SpeakerBar'

import styles from './Media.module.css'
import Controls from './Controls';
import Transcript from './Transcript';
import { firebaseTokenAPI } from '../../services/api/firebase-token';
import { getCookie } from '../../utils/common';


const Media = (
        { 
            totalDuration, keyMomentsData, keyMomentSelectedId, transcript, fileName, filePath, type,
            curTime, duration, playing, isMuted, setPlaying, setClickedTime, setIsMuted, summary,
            customerMessageCount, botMessageCount, agentMessageCount, totalSentiments, utterances,
            keyMoments
        }: any) => {

    const firebaseAuth = getAuth()
    
    const [currentSpeakerData, setCurrentSpeakerData] = useState<{[key: string]: any}>({})
    const [mediaLink, setMediaLink] = useState<string>('')
    const [speakersNames, setSpeakersNames] = useState<{[key: string]: any}>({})

    useEffect(() => {
        // Enable if the conversation is of type audio
        // getCustomTokenForFirebase()

        // getSpeakerNames()
    }, [])

    useEffect(() => {
        // This function is used to get the currentSpeaker data
        if(curTime) {
            if(currentSpeakerData && Object.keys(currentSpeakerData).length) {
                // match the end time and curTime with the currentSpeakerData then update
                if((curTime < currentSpeakerData.start/100) || (curTime > currentSpeakerData.end/100)) {
                    getCurrentSpeakerData()
                }
            } else {
                // If no current Speaker then by default set the current speaker to transcript[0]
                getCurrentSpeakerData()
            }
        }
    }, [curTime])

    /**
     * result: Speaker data
     * 
     * Optimize: Binary search may be the best algorithm to get the data instead of sequential search
     */ 
    const getCurrentSpeakerData = () => {
        if(curTime) {
            let currentSpeaker = transcript.agent_customer_data.filter((item: {[key: string]: any}) => {
                    if(curTime >= item.start && curTime <= item.end) {
                        item.speakerIndex = Object.keys(speakersNames).indexOf(item.speaker)
                        return item
                    }
            })
            currentSpeaker = currentSpeaker && currentSpeaker.length ? currentSpeaker[0] : {} 
            setCurrentSpeakerData(currentSpeaker)
        }
    }

    // get Speaker names
    const getSpeakerNames = () => {
        let names: {[key: string]: any} = {}
        Object.keys(transcript.agent_customer_data).map(item => {
            if(item !== 'utterances') {
                names[item] = transcript.agent_customer_data[item].name
            }
        })
        setSpeakersNames(names)
    }

    // Firebase upload starts here
    const getCustomTokenForFirebase = () => {
        const user = firebaseAuth.currentUser
        if (user) {
            // If User is signed in
            getConversationURL()
        } else {
            const tenantSlug = getCookie('current_tenant')
            firebaseTokenAPI(tenantSlug).getAll?.()
                .then((response) => {
                    authenticateFirebase(response.firebase_token)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    const authenticateFirebase = (token: string) => {
        signInWithCustomToken(firebaseAuth, token)
        .then(() => {
            getConversationURL()
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log("errorCode : "+errorCode);
            console.log("errorMessage : "+errorMessage);
        });
    }

    // Get Transcript and Audio/Video links from firebase
    const getConversationURL = async () => {
        let splitIndex = fileName.indexOf('_')
        const mediaFileName = type === 'AUDIO' ? fileName.substring(0, splitIndex) : fileName
        let mediaLink = await getConversationLink(mediaFileName)
        setMediaLink(mediaLink)
    }

    const getConversationLink = (fileName: string) => {
        return getDownloadURL(ref(storage, `${filePath}/${fileName}`))
            .then((url) => {
                return url
            })
            .catch((error) => {
                console.log(error)
                return ''
                // Handle any errors
            });
    }

    return (
        <div className={styles.mediaContainer}>            
            {/* Display audio/video or transcript */}
            <div id="media-player" className={styles.mediaPlayer}  style={{width:'100%'}}>
                <div className={`${styles.mediaContainerTabs}`}>
                    <h6 className={styles.active}>Conversation Summary</h6>
                    <p className={styles.content}>{summary?.summary ? summary?.summary : summary }</p>
                </div>
                <div className={styles.transcriptContainerBlock}>                    
                    <Transcript
                        // speakersNames={speakersNames}
                        transcript={transcript?.agent_customer_data} 
                        onTimeUpdate={(time: number) => setClickedTime(time)}
                        curTime={curTime}
                        type={type}
                        totalSentiments={totalSentiments}
                        utterances={utterances}
                        keyMoments={keyMoments}
                    />
                </div>
            </div>
            <div className={`${styles.mediaFooter}`}>
                {
                    type === 'audio' &&
                        <Controls 
                            playing={playing}
                            setPlaying={setPlaying}
                            curTime={curTime}
                            duration={duration}
                            isMuted={isMuted}
                            handleMute={() => setIsMuted(!isMuted)}
                        />
                }
                {
                    type === 'audio' &&
                        <ProgressBar 
                            curTime={curTime} 
                            duration={duration} 
                            onTimeUpdate={(time: number) => setClickedTime(time)}
                            keyMomentsData={keyMomentsData}
                            keyMomentSelectedId={keyMomentSelectedId}
                            currentSpeakerData={currentSpeakerData} 
                        />
                }
                {
                    type == 'audio' &&
                        <SpeakerBar
                            speakers={transcript}
                            botMessageCount={botMessageCount}
                            agentMessageCount={agentMessageCount}
                            customerMessageCount={customerMessageCount}
                            totalDuration={totalDuration}
                            type={type}
                        />
                }
            </div>
        </div>
    )
}

export default Media
